import { Dialog } from "@ark-ui/react";
import { cn } from "@base/lib/utils";
import type { ComponentProps } from "react";

type Props = ComponentProps<typeof Dialog.Description> & {
  className?: string;
};

const Description = ({ className, ...rest }: Props) => (
  <Dialog.Description className={cn("text-center text-gray-1000 text-body2", className)} {...rest} />
);

export default Description;
